export default class Beeper {
  private static audioContext: AudioContext;

  static playBeep(duration: number, frequency: number, volume: number) {
    if (!Beeper.audioContext) {
      Beeper.audioContext = new AudioContext();
    }

    const oscillator = Beeper.audioContext.createOscillator();
    oscillator.type = 'sine';
    oscillator.frequency.value = frequency;
    const gainNode = Beeper.audioContext.createGain();
    gainNode.connect(Beeper.audioContext.destination);
    gainNode.gain.value = volume;
    oscillator.connect(gainNode);
    oscillator.start();
    setTimeout(() => oscillator.stop(), duration * 1000);
  }
}
